import { Transaction } from '../queries/Transaction'
import { TRANSACTION_STATUSES } from './constants'

/**
 * Checks to see if a transaction is in a finished state.
 *
 * @param transaction the transaction to check.
 * @returns true if the transaction is complete, false otherwise
 */
export const isTransactionFinished = (transaction: Transaction) => {
  return (
    transaction.status && transaction.status !== TRANSACTION_STATUSES.PROCESSING
  )
}
